const ContactMeta = require('./ContactMeta.jsx');
const LineItemCell = require('./LineItemCell.jsx');
const LineItems = require('./LineItems.jsx');
const Meta = require('./Meta.jsx');
const Name = require('../utility/Name.jsx');

const Blocks = {
    get: (group, data) => [
        {
            id: 'purchaseOrderSeparator',
            dataType: 'separator', 
            display: 'Purchase Order', 
            group
        },
        {
            id: Name.Block.Client.ContactMeta,
            component: ContactMeta.Component,
            config: {
                Block: ContactMeta.TypeConfig.panel.block(),
                Style: ContactMeta.TypeConfig.panel.style()
            },
            display: 'Contact Meta',
            group,
            image: ''
        },
        {
            id: Name.Block.Name,
            component: Meta.Name.Component,
            config: {
                Block: Meta.Name.TypeConfig.panel.block(),
                Style: Meta.Name.TypeConfig.panel.style(),
                Description: Meta.Name.TypeConfig.panel.description(),
                Label: Meta.Name.TypeConfig.panel.label(),
                Value: Meta.Name.TypeConfig.panel.value()
            },
            display: 'Purchase Order Name',
            group,
            image: ''
        },
        {
            id: Name.Block.Number,
            component: Meta.Number.Component,
            config: {
                Block: Meta.Number.TypeConfig.panel.block(),
                Style: Meta.Number.TypeConfig.panel.style(),
                Description: Meta.Number.TypeConfig.panel.description(),
                Label: Meta.Number.TypeConfig.panel.label(),
                Value: Meta.Number.TypeConfig.panel.value()
            },
            display: 'Purchase Order Number',
            group,
            image: ''
        },
        {
            id: Name.Block.Date,
            component: Meta.Date.Component,
            config: {
                Block: Meta.Date.TypeConfig.panel.block(),
                Style: Meta.Date.TypeConfig.panel.style(),
                Description: Meta.Date.TypeConfig.panel.description(),
                Label: Meta.Date.TypeConfig.panel.label(),
                Value: Meta.Date.TypeConfig.panel.value()
            },
            display: 'Purchase Order Date',
            group,
            image: ''
        },
        {
            id: Name.Block.Company.StaffName,
            component: Meta.Staff.Component,
            config: {
                Block: Meta.Staff.TypeConfig.panel.block(),
                Style: Meta.Staff.TypeConfig.panel.style(),
                Description: Meta.Staff.TypeConfig.panel.description(),
                Label: Meta.Staff.TypeConfig.panel.label(),
                Value: Meta.Staff.TypeConfig.panel.value(),
                Visibility: Meta.Staff.TypeConfig.panel.visibility()
            },
            display: 'Staff Name',
            group,
            image: ''
        },
        {
            id: Name.Block.TrackingNumber,
            component: Meta.TrackingNumber.Component,
            config: {
                Block: Meta.TrackingNumber.TypeConfig.panel.block(),
                Style: Meta.TrackingNumber.TypeConfig.panel.style(),
                Description: Meta.TrackingNumber.TypeConfig.panel.description(),
                Label: Meta.TrackingNumber.TypeConfig.panel.label(),
                Value: Meta.TrackingNumber.TypeConfig.panel.value()
            },
            display: 'Tracking Number',
            group,
            image: ''
        },
        {
            id: Name.Block.Stage,
            component: Meta.Stage.Component,
            config: {
                Block: Meta.Stage.TypeConfig.panel.block(),
                Style: Meta.Stage.TypeConfig.panel.style(),
                Description: Meta.Stage.TypeConfig.panel.description(),
                Label: Meta.Stage.TypeConfig.panel.label(),
                Value: Meta.Stage.TypeConfig.panel.value()
            },
            display: 'Stage',
            group,
            image: ''
        },
        {
            id: Name.Block.Notes,
            component: Meta.Notes.Component,
            config: {
                Block: Meta.Notes.TypeConfig.panel.block(),
                Style: Meta.Notes.TypeConfig.panel.style(),
                Description: Meta.Notes.TypeConfig.panel.description(),
                Label: Meta.Notes.TypeConfig.panel.label(),
                Value: Meta.Notes.TypeConfig.panel.value(),
                Visibility: Meta.Notes.TypeConfig.panel.visibility('Purchase Order Notes')
            },
            display: 'Purchase Order Notes',
            group,
            image: ''
        },
        {
            id: Name.Block.Inventory.List,
            component: LineItems.Component,
            config: {
                Block: LineItems.TypeConfig.panel.block(),
                Style: LineItems.TypeConfig.panel.style(),
                Visibility: LineItems.TypeConfig.panel.visibility(),
                defaults: [
                    { configName: 'Block', propertyName: 'design', propertyValue: LineItemCell.Container.TypeConfig.defaultDesign(data) }
                ]
            },
            display: 'Line Items',
            group,
            image: ''
        },
        // {
        //     id: Name.Block.Total.Subtotal,
        //     component: Totals.Subtotal.Component,
        //     config: {
        //         Block: Totals.Subtotal.TypeConfig.panel.block(),
        //         Style: Totals.Subtotal.TypeConfig.panel.style(),
        //         Label: Totals.Subtotal.TypeConfig.panel.label(),
        //         Value: Totals.Subtotal.TypeConfig.panel.value(data)
        //     },
        //     display: 'Subtotal',
        //     group,
        //     image: ''
        // },
        // {
        //     id: Name.Block.Total.Taxes,
        //     component: Totals.Taxes.Component,
        //     config: {
        //         Block: Totals.Taxes.TypeConfig.panel.block(),
        //         Style: Totals.Taxes.TypeConfig.panel.style(),
        //         Label: Totals.Taxes.TypeConfig.panel.label(),
        //         Value: Totals.Taxes.TypeConfig.panel.value(data)
        //     },
        //     display: 'Taxes',
        //     group,
        //     image: ''
        // },
        // {
        //     id: Name.Block.Total.Shipping,
        //     component: Totals.Shipping.Component,
        //     config: {
        //         Block: Totals.Shipping.TypeConfig.panel.block(),
        //         Style: Totals.Shipping.TypeConfig.panel.style(),
        //         Label: Totals.Shipping.TypeConfig.panel.label(),
        //         Value: Totals.Shipping.TypeConfig.panel.value(data)
        //     },
        //     display: 'Shipping Cost',
        //     group,
        //     image: ''
        // },
        // {
        //     id: Name.Block.Total.GrandTotal,
        //     component: Totals.GrandTotal.Component,
        //     config: {
        //         Block: Totals.GrandTotal.TypeConfig.panel.block(),
        //         Style: Totals.GrandTotal.TypeConfig.panel.style(),
        //         Label: Totals.GrandTotal.TypeConfig.panel.label(),
        //         Value: Totals.GrandTotal.TypeConfig.panel.value(data)
        //     },
        //     display: 'Grand Total',
        //     group,
        //     image: ''
        // }
    ],
    content: {
        [Name.Block.Inventory.List]: LineItemCell.Container.Blocks
    },
    tokens: (id, data) => {
        switch (id) {
            case Name.Block.Client.ContactMeta:
                return ContactMeta.Tokens();
            case Name.Block.Company.StaffName:
                return Meta.Staff.Tokens();
            case Name.Block.Date:
                return Meta.Date.Tokens();
            case Name.Block.Inventory.Meta:
                return LineItemCell.Meta.Tokens(data);
            case Name.Block.Name:
                return Meta.Name.Tokens();
            case Name.Block.Number:
                return Meta.Number.Tokens(Name.Config.PurchaseOrder);
            case Name.Block.Stage:
                return Meta.Stage.Tokens();
            case Name.Block.TrackingNumber:
                return Meta.TrackingNumber.Tokens();
            // case Name.Block.Total.GrandTotal:
            //     return Totals.GrandTotal.Tokens(data);
            // case Name.Block.Total.Shipping:
            //     return Totals.Shipping.Tokens(data);
            // case Name.Block.Total.Subtotal:
            //     return Totals.Subtotal.Tokens(data);
            // case Name.Block.Total.Taxes:
            //     return Totals.Taxes.Tokens(data);
        }
    }
};

module.exports = {
    Blocks
};